module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = ../../../../readable-stream/lib/internal/streams/stream-browser.js
// module chunks = 5